import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import {  Box, ListItemText, Menu, MenuItem, SxProps } from "@mui/material";
import { themeSettings } from "../../../../configuration/themeSettings";

export const useClasses = {
    icon: {
        fontSize: 32,
    } as SxProps,
};




export const ContainerNameBasket = styled("div", {
    label: "AppBasketMenu-containerNameBasket",
})(({ theme: Theme }) => ({
    display: 'flex',
}));

export const TextBasket = styled(ListItemText, {
    label: "AppBasketMenu-textBasket",
})(({ theme: Theme }) => ({

    paddingLeft: 5 + "px !important",
    'span': {
        fontSize: 12,
        lineHeight: '14px',
        
    }
}));

export const MenuItemCustom = styled(MenuItem, {
    label: "AppBasketMenu-menuItemCustom",
})(({ theme: Theme }) => ({
    borderBottomColor: themeSettings.main.palette.grey[500],
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    paddingLeft: 5,
    paddingRight: 5,
    
    "":{

    }
}));

export const StyledMenu = styled(Menu, {
    label: "AppBasketMenu-menuMenu",
})(({ theme: Theme }) => ({
    margin: "2px",
    width: "400px",
    maxWidth: "400px",
    height: "500px",
    maxHeight: "500px",
}));